import React from "react";
import styles from "./Faqbody.module.scss";
import ActiveBlock from "./assets/activeBlock.png";
import InActiveBlock from "./assets/inActiveBlock.png";
const { fBody, header, content, block, activeBlockC } = styles;

const FaqBody = () => {
  const [activeBlock, setActiveBlock] = React.useState(null);
  return (
    <div className={`${fBody} global-lr-pad`}>
      <div className={header}>
        <h2>SHOP - PAY -SAVE</h2>
        <h1>Frequently Asked Questions</h1>
        <p>Our support team is available 24/7 if you ever get stuck</p>
      </div>
      <div className={content}>
        <Block
          active={true}
          header={"How secure Is WeQuick Pay for online payment?"}
        >
          Your money and data are both safe when you pay money through WeQuick
          Pay. Our encrypted QRcodes are laced with the highest level of
          security ensuring a smooth transaction without pathway lapses.
        </Block>
        <Block
          active={false}
          header={"Is WeQuick Pay a registered payment platform?"}
        ></Block>
        <Block
          active={false}
          header={
            "What makes WeQuick Pay different from other payment platforms? "
          }
        ></Block>
        <Block
          active={false}
          header={"Do you charge fees on transactions?"}
        ></Block>
      </div>
    </div>
  );
};

const Block = (props) => {
  return (
    <div className={`${block} ${props.active ? activeBlockC : ""}`}>
      <div>
        <h1>{props.header}</h1>
        <img
          src={props.active ? ActiveBlock : InActiveBlock}
          alt="View details toggler"
        />
      </div>
      {props.active && <div>{props.children}</div>}
    </div>
  );
};
export default FaqBody;
